/*
  tpt-marquee
  เลื่อนข้อความเฉพาะตอนที่ยาวเกินพื้นที่ ถ้าพอดีจะแสดงเป็นข้อความปกติ
  - วัดใหม่ทุกครั้งที่ขนาดเปลี่ยน (ResizeObserver) และหลังโหลดฟอนต์เสร็จ
  - ทำสำเนาข้อความ 1 ชุด (aria-hidden) เพื่อให้วนต่อกันได้ไม่มีช่องว่าง
  - ถ้าอยู่ใน swiper slide จะตั้ง data-swiper-autoplay ให้ slide ค้างจนเลื่อนครบ 1 รอบ
  - เคารพ prefers-reduced-motion (ไม่เลื่อน แสดงแบบตัดบรรทัดปกติ)
*/
(function () {
  if (!('customElements' in window) || customElements.get('tpt-marquee')) return;

  var HOLD_SECONDS = 1.5; // หยุดค้างตอนเริ่ม ให้อ่านต้นข้อความได้ก่อนเลื่อน
  var MIN_SLIDE_DELAY = 5000; // ต้องตรงกับ autoplay.delay ใน section
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class TptMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.simple-promotion__marquee-track');
      if (!this.track) return;

      this.lastWidth = -1;
      this.onResize = this.schedule.bind(this);

      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(this.onResize);
        this.observer.observe(this);
      } else {
        window.addEventListener('resize', this.onResize);
      }

      var self = this;
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
          self.update();
        });
      }

      this.update();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      window.removeEventListener('resize', this.onResize);
      cancelAnimationFrame(this.frame);
    }

    schedule() {
      var self = this;
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(function () {
        if (self.clientWidth !== self.lastWidth) self.update();
      });
    }

    update() {
      var source = this.track.querySelector('.simple-promotion__marquee-item:not([aria-hidden])');
      if (!source) return;

      // reset ให้กลับเป็นสถานะเริ่มต้นก่อนวัด (รองรับกรณี swiper clone element มาทั้งก้อน)
      var copies = this.track.querySelectorAll('.simple-promotion__marquee-item[aria-hidden]');
      for (var i = 0; i < copies.length; i++) copies[i].remove();
      this.classList.remove('is-marquee');

      // วัดความกว้างข้อความแบบบรรทัดเดียว เทียบกับพื้นที่ที่มี
      this.classList.add('is-measuring');
      var fits = source.getBoundingClientRect().width <= this.clientWidth + 1;
      this.classList.remove('is-measuring');

      var slide = this.closest('.swiper-slide');

      if (fits || reducedMotion.matches) {
        if (slide) slide.removeAttribute('data-swiper-autoplay');
        this.lastWidth = this.clientWidth;
        return;
      }

      var copy = source.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      var focusables = copy.querySelectorAll('a, button, input, select, textarea, [tabindex]');
      for (var j = 0; j < focusables.length; j++) focusables[j].setAttribute('tabindex', '-1');
      this.track.appendChild(copy);

      this.classList.add('is-marquee');

      var speed = parseFloat(this.dataset.speed) || 50;
      var distance = source.getBoundingClientRect().width; // รวมระยะห่างระหว่างชุดแล้ว
      var duration = distance / speed;

      this.style.setProperty('--marquee-duration', duration.toFixed(2) + 's');
      this.style.setProperty('--marquee-delay', HOLD_SECONDS + 's');

      if (slide) {
        var slideDelay = Math.round((HOLD_SECONDS + duration) * 1000) + 500;
        slide.setAttribute('data-swiper-autoplay', String(Math.max(MIN_SLIDE_DELAY, slideDelay)));
      }

      this.lastWidth = this.clientWidth;
    }
  }

  customElements.define('tpt-marquee', TptMarquee);
})();